// NB: THIS FILE MUST BE IN ES5

// Browser native fetch implementation does not support the http(s) Agent like node-fetch does
export class Agent {}
